var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service, { inject as service } from '@ember/service';
import { computed } from '@ember/object';
import { filterBy } from '@ember/object/computed';
import environment from '@square/environment-utils/environment';
import { PrepareMigrationExternalRequest, ExternalThirdPartyMigrationService, StartMigrationExternalRequest, UpdateAdditionalAttributesExternalRequest } from '@square/dashboard-protos/models/squareup/catalogmigrator/external';
import { CatalogType, ImportProvider, Status as CatalogMigratorStatus, Error as CatalogMigratorError } from '@square/dashboard-protos/models/squareup/catalogmigrator/common';
import { WoflowLink } from '@woflowinc/link';
import rpc from '@square/dashboard-utilities/clients/rpc';
export let WoflowOnDataStatesEnum = /*#__PURE__*/function (WoflowOnDataStatesEnum) {
  WoflowOnDataStatesEnum["IN_PROGRESS"] = "in_progress";
  WoflowOnDataStatesEnum["PENDING_APPROVAL"] = "pending_approval";
  WoflowOnDataStatesEnum["EXPORT_IN_PROGRESS"] = "export_in_progress";
  return WoflowOnDataStatesEnum;
}({});
export let WoflowLinkConfiguration = /*#__PURE__*/function (WoflowLinkConfiguration) {
  WoflowLinkConfiguration["MIGRATE_MENU"] = "MIGRATE_MENU";
  WoflowLinkConfiguration["UPLOAD_MENU"] = "UPLOAD_MENU";
  return WoflowLinkConfiguration;
}({});
export let WoflowLinkCountries = /*#__PURE__*/function (WoflowLinkCountries) {
  WoflowLinkCountries["US"] = "US";
  WoflowLinkCountries["GB"] = "GB";
  WoflowLinkCountries["CA"] = "CA";
  WoflowLinkCountries["AU"] = "AU";
  WoflowLinkCountries["IE"] = "IE";
  WoflowLinkCountries["FR"] = "FR";
  WoflowLinkCountries["ES"] = "ES";
  return WoflowLinkCountries;
}({});
export const PRODUCTION_PUBLIC_KEY = 'b308d7f0b2dc829cd797e922e82da0fe';
export const STAGING_PUBLIC_KEY = 'e083c24204d8862080f347b57525a836';
export const WOFLOW_CONFIG = {
  US: {
    STAGING: {
      MIGRATE_MENU: '237a4e86-6c0e-4d2f-836f-3f836f1dec83',
      UPLOAD_MENU: '7050c9d9-152e-4875-8f35-7bc8a17a6bca'
    },
    PRODUCTION: {
      MIGRATE_MENU: '24a3677d-7baf-458c-8804-fc6986d91a44',
      UPLOAD_MENU: '7887ddfb-1e02-42dc-97ee-f2194ac72ee1'
    }
  },
  GB: {
    STAGING: {
      MIGRATE_MENU: '7c6bc34f-bdb3-4327-a89d-4120a3f99456',
      UPLOAD_MENU: '130bee12-f998-4c5f-b828-d9a4300eb49f'
    },
    PRODUCTION: {
      MIGRATE_MENU: '297b9ab7-a2f2-4ce6-b13b-f63d6a3eeb13',
      UPLOAD_MENU: '90089070-5225-4fbf-a638-60365e03be3a'
    }
  },
  CA: {
    STAGING: {
      MIGRATE_MENU: 'feb51aee-a1b6-45be-92e1-a45d2100d0af',
      UPLOAD_MENU: '8593dc61-8f05-4700-abe1-a6fa88412deb'
    },
    PRODUCTION: {
      MIGRATE_MENU: '3a8e943b-fc4c-42b9-87e6-0656a5c24ae2',
      UPLOAD_MENU: '845fa560-7980-4e73-b917-c1040edff8c0'
    }
  },
  AU: {
    STAGING: {
      MIGRATE_MENU: '4dfc9f3d-22fa-4419-bbf3-d9f37d2df656',
      UPLOAD_MENU: '293fe046-6a0a-426a-881c-83ffb9eb9e48'
    },
    PRODUCTION: {
      MIGRATE_MENU: '2a87465c-7883-404b-a125-4fe489cd9dce',
      UPLOAD_MENU: '181d098d-a77c-4dd4-af03-58c6c329950c'
    }
  },
  IE: {
    STAGING: {
      MIGRATE_MENU: 'd62fced5-653f-4608-a2d9-0fc713c16c7f',
      UPLOAD_MENU: 'd490b392-e4e8-4363-8f06-fdd4a7a7e696'
    },
    PRODUCTION: {
      MIGRATE_MENU: 'a9fbafab-7915-471c-abf4-b169cb038e8f',
      UPLOAD_MENU: 'e815afcf-186f-4d63-9455-7b20c87f933b'
    }
  },
  ES: {
    STAGING: {
      MIGRATE_MENU: '132d5287-19b5-456d-a89c-b40d22deb365',
      UPLOAD_MENU: 'dcfa66a3-fe43-4558-af59-ea92856637bd'
    },
    PRODUCTION: {
      MIGRATE_MENU: '174d02c0-8380-4509-9b1c-0953e0bbc7f5',
      UPLOAD_MENU: '1e60d219-712b-44b2-8b3c-ff28c088e6cb'
    }
  },
  FR: {
    STAGING: {
      MIGRATE_MENU: 'de6efe3b-5c64-47ec-859e-7810aa7fbf7b',
      UPLOAD_MENU: 'f146183c-a35b-45e0-a98f-76d1b3d30c11'
    },
    PRODUCTION: {
      MIGRATE_MENU: '26e1788e-4869-4137-8a7f-314bfe9e384c',
      UPLOAD_MENU: '82f32a71-d7c5-43c0-9426-f55b4d3d81ef'
    }
  }
};

/**
 * Service for integrating Woflow functionality within an Ember application.
 * This service is responsible for:
 * - Generating a JWT for Woflow authentication using the selected merchant unit's details and a
 * menu import token
 * - Initializing Woflow with specific configurations
 * - Handling the woflow link iframe
 * - Updating menu attributes
 *
 * @example
 * ```javascript
 * import Component from '@glimmer/component';
 * import { inject as service } from '@ember/service';
 *
 * export default class ExampleComponent extends Component {
 *   @service('restaurants/woflow-link-service') woflowLinkService;
 *
 *   someMethod() {
 *     this.woflowLinkService.initialize(WoflowLinkConfiguration.UPLOAD_MENU, onData, onClose, onError);
 *   }
 * }
 * ```
 *
 * @example
 * ```javascript
 * // For non-omnichannel menus, only the menuName is required
 * await this.woflowLink.updateMenuAttributes({ menuName });
 * ```
 *
 * // For omnichannel menus, there's the `
 *  omnichannelAttributes: {
 *     unitTokens,
 *     channelIds,
 *     availabilityPeriods,
 *     onlineChannelsVisible
 *   }` that need to be
 *   provided
 * ```javascript
 *   await this.woflowLink.updateMenuAttributes({
 *     menuName: args.menuName,
 *     omnichannelAttributes: {
 *       unitTokens: args.unitTokens,
 *       channelIds: args.channels.toArray(),
 *       availabilityPeriods: args.availabilityPeriods?.map((a) => a.id) ?? [],
 *       onlineChannelsVisible: true | false,
 *     },
 *   });
 * ```
 *
 * @class WoflowLinkService
 * @extends Service
 */
let WoflowLinkService = (_dec = computed('userInfo.merchantToken'), _dec2 = filterBy('locationSelector.sortedUnits', 'unitActive'), _class = class WoflowLinkService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "userInfo", _descriptor, this);
    _initializerDefineProperty(this, "locationSelector", _descriptor2, this);
    _defineProperty(this, "menuImportToken", null);
    _initializerDefineProperty(this, "sortedUnits", _descriptor3, this);
  }
  get merchantToken() {
    return this.userInfo.merchantToken;
  }
  get initialSelectedLocation() {
    return this.sortedUnits[0];
  }

  /**
   * Initializes the [Woflow link](https://docs.woflow.com/link/sdk) with the given link
   * configuration and optional callbacks for data and close events.
   *
   * 1. Prepares the Woflow link by generating menu_import
   *    if one doesn't exist, or retrieves an existing on in status NOT_STARTED,
   *    embeds it in a JWT for Woflow authentication, and stores the menu import token for updates.
   * 2. Initializes Woflow with the generated JWT and the given link configuration
   * 3. Handles data and close events from the Woflow iframe through callbacks
   *
   * @param {WoflowLinkConfiguration} linkConfigurationType - The type of Woflow link configuration
   *   to initialize.
   * @param {(data: any) => void} [onData] - Optional callback to handle data received from Woflow.
   * @param {() => void} [onClose] - Optional callback to handle the closing of the Woflow iframe.
   * @param onError - Optional callback to handle errors that occur during the Woflow onData callback.
   * @returns {Promise<void>}
   */
  async initialize(linkConfigurationType, onData, onClose, onError) {
    const env = environment();
    // default to US flow if country code is not valid
    const CONFIG = WOFLOW_CONFIG[this.userInfo.countryCode] || WOFLOW_CONFIG.US;
    const PUBLIC_KEY = env.isProduction ? PRODUCTION_PUBLIC_KEY : STAGING_PUBLIC_KEY;
    const LINK_CONFIGS = env.isProduction ? CONFIG.PRODUCTION : CONFIG.STAGING;
    const linkConfigurationId = LINK_CONFIGS[linkConfigurationType];
    let jwt;
    try {
      jwt = await this.prepareWoflowLink();
    } catch {
      throw new Error('Failed to prepare Woflow link');
    }
    const options = {
      jwt,
      publicKey: PUBLIC_KEY,
      linkConfigurationId
    };
    const link = this.createWoflowLink(options);
    link.openIframe({
      onData: async data => {
        const isInProgress = data?.state === WoflowOnDataStatesEnum.IN_PROGRESS || data?.state === WoflowOnDataStatesEnum.EXPORT_IN_PROGRESS;
        if (isInProgress) {
          try {
            await this.updateMenuImportStatusToInProgress(linkConfigurationType);
            if (onData) {
              await onData(data);
            }
          } catch (error) {
            if (onError) {
              // Notify caller of woflow-link-service that an error occurred
              onError(error);
            }
          }
        }
      },
      onClose: () => {
        if (onClose) {
          // No need to update status here since status will remain in NOT_STARTED,
          // and it will be cleared with ExpiredWoflowMenuImportCronJob
          onClose();
        }
      }
    });
  }

  /**
   * Updates the menu attributes based on the provided parameters.
   * If the `omnichannelAttributes` property is present in the parameters, the menu is considered
   * to be omnichannel, and the method will use the `unitTokens` and `channelIds` for the update.
   * If the `omnichannelAttributes` property is not present, it's a non-omnichannel menu, and the
   * method will use the `unitToken` of the initially selected location. In both cases, the stored
   * `menuImportToken` is used in the request.
   *
   * @param {UpdateMenuAttributesParams} params - The parameters for the menu update.
   * @throws Will throw an error if `menuImportToken` is not available.
   * @returns {Promise<UpdateAdditionalAttributesResponse>}
   *
   * @example
   * // Update a non-omnichannel menu
   * this.woflowLinkService.updateMenuAttributes({ menuName: 'Test Menu' });
   *
   * @example
   * // Update an omnichannel menu
   * this.woflowLinkService.updateMenuAttributes({
   *   menuName: 'Test Menu',
   *   omnichannelAttributes: {
   *     unitTokens: ['unit1', 'unit2'],
   *     channelIds: ['channel1', 'channel2'],
   *     availabilityPeriodIds: ['period1', 'period2'],
   *     onlineChannelsVisible: true,
   *   }
   * });
   */
  async updateMenuAttributes(params) {
    const {
      menuName
    } = params;
    if (!this.menuImportToken) {
      throw new Error('No menuImportToken is available');
    }
    let request;
    if ('omnichannelAttributes' in params) {
      const {
        omnichannelAttributes: {
          unitTokens,
          channelIds,
          availabilityPeriodIds,
          onlineChannelsVisible,
          menuChannelIntegrations,
          menuLocationChannelIntegrations,
          menuAvailabilityPeriods
        }
      } = params;
      request = UpdateAdditionalAttributesExternalRequest.create({
        catalogImportToken: this.menuImportToken,
        menuAttributes: {
          menuName,
          isOmnichannel: true,
          unitTokens,
          channelIds,
          availabilityPeriodIds,
          onlineChannelsVisible,
          menuChannelIntegrations,
          menuLocationChannelIntegrations,
          menuAvailabilityPeriods
        }
      });
    } else {
      const {
        token: unitToken
      } = this.initialSelectedLocation;
      request = UpdateAdditionalAttributesExternalRequest.create({
        catalogImportToken: this.menuImportToken,
        menuAttributes: {
          menuName,
          unitTokens: [unitToken]
        }
      });
    }
    const response = await ExternalThirdPartyMigrationService.create(rpc()).updateAdditionalAttributes(request);
    if (response.status === CatalogMigratorStatus.STATUS_SUCCESS) {
      return response;
    } else if (response.error === CatalogMigratorError.ERROR_NOT_ACCEPTING_MENU_MIGRATIONS) {
      throw new Error('CatalogMigrator: Not accepting menu migrations at this time');
    } else {
      throw new Error('CatalogMigrator: Unknown error occurred while updating catalog');
    }
  }

  /**
   * Generates a JWT for Woflow authentication using the selected merchant unit's details and a
   * menu import token. This method is private and not intended for direct external use.
   *
   * @returns {Promise<string>} The JWT token for Woflow authentication.
   * @private
   */
  async prepareWoflowLink() {
    const {
      token: unitToken,
      nickname: unitNickname
    } = this.initialSelectedLocation;
    const payload = {
      unitToken,
      unitNickname,
      catalogType: CatalogType.CATALOG_TYPE_MENU
    };
    const request = PrepareMigrationExternalRequest.create(payload);
    const response = await ExternalThirdPartyMigrationService.create(rpc()).prepareMigration(request);
    const {
      catalogImportToken,
      woflowJwt
    } = response;
    this.menuImportToken = catalogImportToken;
    return woflowJwt;
  }

  /**
   * Instantiates WoflowLink, primarily to help mocking in tests.
   *
   * @param {WoflowLinkOptions} options Configuration options for WoflowLink.
   * @returns {WoflowLink} An instance of WoflowLink.
   */
  createWoflowLink(options) {
    return new WoflowLink(options);
  }
  async updateMenuImportStatusToInProgress(linkConfigurationType) {
    if (!this.menuImportToken) {
      throw new Error('No menuImportToken is available');
    }
    const importProvider = this.mapLinkConfigurationTypeToImportProvider(linkConfigurationType);
    const request = StartMigrationExternalRequest.create({
      catalogImportToken: this.menuImportToken,
      importProvider
    });
    const response = await ExternalThirdPartyMigrationService.create(rpc()).startMigration(request);
    if (response.status !== CatalogMigratorStatus.STATUS_SUCCESS) {
      if (response.error === CatalogMigratorError.ERROR_NOT_ACCEPTING_MENU_MIGRATIONS) {
        throw new Error('CatalogMigrator: Not accepting menu migrations at this time');
      } else {
        throw new Error('CatalogMigrator: Unknown error occurred while updating catalog');
      }
    }
  }
  mapLinkConfigurationTypeToImportProvider(linkConfigurationType) {
    switch (linkConfigurationType) {
      case WoflowLinkConfiguration.MIGRATE_MENU:
        return ImportProvider.IMPORT_PROVIDER_WOFLOW_LINK_MIGRATION;
      case WoflowLinkConfiguration.UPLOAD_MENU:
        return ImportProvider.IMPORT_PROVIDER_WOFLOW_LINK_UPLOAD;
      default:
        throw new Error(`Unsupported WoflowLinkConfiguration: ${linkConfigurationType}`);
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "locationSelector", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "merchantToken", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "merchantToken"), _class.prototype), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "sortedUnits", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { WoflowLinkService as default }; // This is how TypeScript knows how to look up the service.
/** @hidden */